import Filter from "../Filter/Filter";
import React from "react";
import SearchPanel from "../SearchPanel";
import '../Filter/Filter.scss';
import Input from "../Input-new/Input";
import SelectFirm from "../SelectFirm/SelectFirm";

export default class InvestorListFilter extends Filter {
	constructor(props) {
		super(props);
	}

	render() {
		const {query} = this.state;

		return (
			<div ref='main' className='Filter'>
				<div className='Filter_content'>
					{React.cloneElement(this.props.children, {openFilter: () => this.openFilter(), userData: this.props.userData})}
				</div>
				<SearchPanel ref='searchPanel'>
					<nav className='Filter_nav'>
						<div className='Filter_button' onClick={this.close}>Close</div>
					</nav>
					<form className='SearchPanel_form' style={{padding: '20px'}} onSubmit={this.handleSubmit}>
						<Input
							theme='dark'
							valueType='text'
							name='NAME'
							label='Name'
							value={query.NAME}
							handleParentChange={this.handleChange}
						/>
						<Input
							theme='dark'
							valueType='text'
							name='EMAIL'
							label='Email'
							value={query.EMAIL}
							handleParentChange={this.handleChange}
						/>
						<Input
							theme='dark'
							valueType='phone'
							name='PHONE'
							label='Work'
							value={query.PHONE}
							handleParentChange={this.handleChange}
						/>
						<Input
							theme='dark'
							valueType='phone'
							name='CELL'
							label='Cell Phone'
							value={query.CELL}
							handleParentChange={this.handleChange}
						/>
						<Input
							theme='dark'
							valueType='text'
							name='LEAD_ID'
							label='Lead ID'
							value={query.LEAD_ID}
							handleParentChange={this.handleChange}
						/>
						<SelectFirm
							theme='dark'
							valueKey='FIRM_ID'
							label='Firm'
							value={query.FIRM_ID}
							handleParentChange={this.handleDropdownChange}
							isFilter={true}
						/>
						<div className='button-row'>
							<button type='submit' className='button button--primary'>Apply</button>
							<button type='button' className='button button--secondary' onClick={this.clear}>Clear</button>
						</div>
					</form>
				</SearchPanel>
			</div>
		);
	}
}
